export default __webpack_public_path__ + "media/samples/PAST_STREAMS-4ca58d4e.jpg";